module.exports = __webpack_public_path__ + "img/star.574dbc75.svg";